/**
 * UserManagementPage — Iter 71.4.
 *
 * Standalone page wrapping the cross-tenant User Management Command
 * Center component. Mounted at /platform/users. Platform-admin only —
 * server-side gating returns 403 for non-platform-admins; the page
 * itself just renders the panel which silently no-ops on auth errors.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import UserManagementCommandCenter from "@/components/admin/UserManagementCommandCenter";
import { useAuth } from "@/contexts/AuthContext";

export default function UserManagementPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="p-4 sm:p-6 space-y-4 max-w-7xl mx-auto"
         data-testid="user-management-page">
      <button onClick={() => navigate("/platform")}
              className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-[var(--fop-text-3)] hover:text-[var(--fop-text)]"
              data-testid="um-back-link">
        <ArrowLeft size={13} /> Operations Console
      </button>
      <UserManagementCommandCenter currentActorId={user?.id} />
    </div>
  );
}
